import React, { FC, useEffect } from "react";
import Seo from "components/Seo/Seo";
import { Link } from "react-router-dom";
import { useForm, useAuthStore } from "hooks";
import Swal from "sweetalert2";

export interface PageLoginProps {
  className?: string;
}

const loginFormFields = {
  loginEmail: "",
  loginPassword: "",
};

const inputDark =
  "w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-white placeholder-slate-500 transition focus:border-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-500/30";
const labelDark = "mb-1.5 block text-sm font-medium text-slate-300";
const btnGradient =
  "inline-flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-violet-600 to-fuchsia-600 px-7 py-3 text-base font-bold uppercase tracking-wide text-white shadow-lg shadow-violet-600/30 transition-all duration-200 hover:from-violet-500 hover:to-fuchsia-500 hover:shadow-violet-500/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 active:scale-95 disabled:opacity-70";

const PageLogin: FC<PageLoginProps> = ({ className = "" }) => {
  const { startLogin, errorMessage } = useAuthStore();
  const { loginEmail, loginPassword, onInputChange } = useForm(loginFormFields);

  useEffect(() => {
    if (errorMessage !== undefined) {
      Swal.fire("Error en la autenticación", errorMessage, "error");
    }
  }, [errorMessage]);

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      startLogin({ email: loginEmail, password: loginPassword });
    } catch (error) {
      console.log("Error en el login", error);
    }
  };

  return (
    <div className={`nc-PageLogin relative min-h-screen overflow-hidden bg-black px-4 py-16 ${className}`} data-nc-id="PageLogin">
      <Seo
        path="/login"
        title="Iniciar Sesión | Karaoke Rooms Barcelona"
        description="Accede a tu cuenta de Karaoke Rooms Barcelona para gestionar tus reservas de salas privadas de karaoke."
        noindex
      />

      <div className="relative mx-auto max-w-md">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-3xl font-bold uppercase tracking-wide text-white sm:text-4xl">Acceder</h1>
          <div className="mt-3 h-1 w-20 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500" />
        </div>

        <div className="mt-10 rounded-3xl border border-white/10 bg-white/[0.04] p-6 shadow-2xl backdrop-blur-xl sm:p-8">
          <form className="grid grid-cols-1 gap-5" onSubmit={handleLogin}>
            <div>
              <label htmlFor="loginEmail" className={labelDark}>Correo electrónico</label>
              <input id="loginEmail" type="email" placeholder="ejemplo@ejemplo.com" name="loginEmail" value={loginEmail} onChange={onInputChange} className={inputDark} />
            </div>
            <div>
              <div className="mb-1.5 flex items-center justify-between">
                <label htmlFor="loginPassword" className="text-sm font-medium text-slate-300">Contraseña</label>
                <Link to="/forgot-password" className="text-sm text-violet-300 hover:text-violet-200">¿Has olvidado tu contraseña?</Link>
              </div>
              <input id="loginPassword" type="password" placeholder="••••••••" name="loginPassword" value={loginPassword} onChange={onInputChange} className={inputDark} />
            </div>
            <button type="submit" className={btnGradient}>Acceder</button>
          </form>

          <p className="mt-6 text-center text-sm text-slate-400">
            ¿Nuevo usuario?{" "}
            <Link to="/signup" className="font-semibold text-violet-300 hover:text-violet-200">Crear una cuenta</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageLogin;
